import React from "react";
import "./tooltip.css";
import CloseImfg from "../../images/close.svg";
function ToolTip(props) {
  return (
    <div
      className={
        props.position === "top-right"
          ? "absolute bottom-20 tool-tip-body"
          : props.position === "bottom-left"
          ? "absolute top-14 -left-32 tool-tip-body"
          : ""
      }
    >
      <span>{props.description}</span>
      {props.source === "home" && (
        <div className="flex justify-end mt-2">
          <div
            onClick={() => props.hideHomeTooltip()}
            className="confirm w-fit"
          >
            {props.confirmBtn}
          </div>
        </div>
      )}
      {props.source === "explore" && (
        <div className="flex justify-end mt-2">
          <div
            onClick={() => props.hideExploreTooltip()}
            className="confirm w-fit"
          >
            {props.confirmBtn}
          </div>
        </div>
      )}
      {props.source === "history" && (
        <div className="flex justify-end mt-2">
          <div
            onClick={() => props.hideHistoryTooltip()}
            className="confirm w-fit"
          >
            {props.confirmBtn}
          </div>
        </div>
      )}
      {props.source === "home" && (
        <div
          onClick={() => props.hideHomeTooltip()}
          className="close absolute top-0 right-0 p-1 cursor-pointer"
        >
          <img src={CloseImfg} alt="" />
        </div>
      )}
      {props.source === "explore" && (
        <div
          onClick={() =>props.hideExploreTooltip()}
          className="close absolute top-0 right-0 p-1 cursor-pointer"
        >
          <img src={CloseImfg} alt="" />
        </div>
      )}

      {props.source === "history" && (
        <div
          onClick={() => props.hideHistoryTooltip()}
          className="close absolute top-0 right-0 p-1 cursor-pointer"
        >
          <img src={CloseImfg} alt="" />
        </div>
      )}

      {props.arrowPosition === "bottom" && (
        <div className="arrow rotate-180 absolute -bottom-3 left-8"></div>
      )}
      
      {props.arrowPosition === "top" && (
        <div className="arrow absolute -top-3 right-12"></div>
      )}
    </div>
  );
}

export default ToolTip;
